import React from "react";
import Weight from "./Weight";
import Height from "./Height";
import ImcChart from "./ImcChart"
import Gender from "./Gender";
import Age from "./Age";

export default function ImcEnfant() {
    const [weight, setWeight] = React.useState(undefined)
    const [height, setHeight] = React.useState(undefined)
    const [imc, setImc] = React.useState(undefined)
    const [gender, setGender] = React.useState(null);
    const [age, setAge] = React.useState(undefined);
    const [chartSize, setChartSize] = React.useState({ width: 310, height: 500 });

    React.useEffect(() => {
        if (weight && height) {
            let imc = weight / ((height / 100) * (height / 100))
            setImc(imc)
        } else {
            setImc(undefined)
        }
    }, [weight, height]);

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth >= 640) {
                setChartSize({ width: 440, height: 700 });
            } else {
                setChartSize({ width: 310, height: 500 });
            }
        }

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div className="flex w-full text-center gap-2 sm:gap-4">
                <Gender
                    onClick={() => setGender("male")}
                    gender="male"
                    selected={gender == "male"}
                />
                <Gender
                    onClick={() => setGender("female")}
                    gender="female"
                    selected={gender == "female"}
                />
            </div>

            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg flex gap-8">
                <Weight onChange={(newWeight) => setWeight(newWeight)} />
                <Height onChange={(newHeight) => setHeight(newHeight)} />
            </div>

            <div className="p-4 my-2 sm:my-4 bg-stone-100 rounded-lg flex gap-12">
                <Age onChange={(newAge) => setAge(newAge)} />
            </div>

            <div className="mb-2 font-bold text-center w-full sm:text-lg cursor-default">
                Résultats
            </div>

            <div className="p-4 my-2 sm:my-4 bg-slate-200 rounded-lg w-full">
                <div className="font-semibold mb-1 text-sm sm:text-base">L'IMC de votre enfant est de <span className="font-bold text-lg sm:text-2xl">{imc ? imc.toFixed(1) : "--"}</span> kg/m<sup>2</sup></div>
            </div>

            <ImcChart width={chartSize.width} height={chartSize.height} gender={gender} imc={imc} age={age} />
        </>
    );
}